/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useMutation } from "@tanstack/react-query";

// Services
import { MeetingService } from "@/services/meeting.service";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { downloadFile } from "@/helpers/file.helper";

/* -------------------------------------------------------------------------- */
/*                            Download Report Hook                            */
/* -------------------------------------------------------------------------- */
const meetingService = new MeetingService();

type UseDownloadReportMutationArgs = {
  id: string;
};

const useDownloadReport = ({ id }: UseDownloadReportMutationArgs) => {
  const { t } = useTranslation();
  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      return meetingService.downloadPdf(id);
    },
    onSuccess: (data, _variables, { toastId }) => {
      const blob = new Blob([data as unknown as BlobPart], {
        type: "application/pdf",
      });

      const pdfUrl = URL.createObjectURL(blob);

      downloadFile({ url: pdfUrl, fileName: `Compte_Rendu_${id}.pdf` });
      toast.success(t("global.report_downloaded_successfully"), {
        id: toastId,
      });
    },
    onMutate: () => {
      const toastId = toast.loading(t("global.downloading_report"));
      return { toastId };
    },
  });

  return {
    mutate,
    isPending,
  };
};

export { useDownloadReport };
